import React, { useState } from "react";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const ModalSaveAllInst = ({ onSave, onCancel, insToSave, selectedTurbines, setSelectedTurbines }) => {
    console.log("Instrukcje do zapisania:", insToSave);
    console.log("turbiny  do zapisania:", selectedTurbines);

    const [isSaving, setIsSaving] = useState(false);
    const [saveProgress, setSaveProgress] = useState(0);

    const handleSaveAll = async () => {
      if (selectedTurbines.length === 0) {
        alert("Please select at least one turbine before saving.");
        return;
      }
        setIsSaving(true);
    
        try {
          for (let i = 0; i < insToSave.length; i++) {
            const instruction = insToSave[i];
            const payload = {
              scope_of_work: instruction.scope_of_work_data.id, // ID zakresu pracy
              proper: instruction.proper, // Czy zatwierdzona
              data: instruction.data, // Dane sekcji
              turbine: selectedTurbines, // Lista ID turbin
            };
    
            console.log(`Wysyłanie instrukcji:`, JSON.stringify(payload, null, 2));
    
            const response = await fetch(`${API_BASE_URL}/instructions/`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });
    
            if (!response.ok) {
              throw new Error(`Błąd przy zapisywaniu instrukcji ID ${instruction.id}: ${response.status}`);
            }
    
            // Aktualizacja postępu
            setSaveProgress(Math.round(((i + 1) / insToSave.length) * 100));
          }
    
          alert("Wszystkie instrukcje zostały zapisane!");
        } catch (error) {
          console.error("Błąd podczas zapisywania instrukcji:", error.message);
          alert("Wystąpił błąd podczas zapisywania instrukcji. Sprawdź konsolę.");
        } finally {
          setIsSaving(false);
          setSaveProgress(0);
          setSelectedTurbines([]);
          onSave(); // Zamknięcie modala po zakończeniu
        }
      };

    return (
        <div className="bg-white rounded-2xl border border-steel-200 shadow-sm overflow-hidden">
          <div className="bg-gradient-to-r from-green-50 to-white px-6 py-4 border-b border-green-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                  <polyline points="17 21 17 13 7 13 7 21"/>
                  <polyline points="7 3 7 8 15 8"/>
                </svg>
              </div>
              <div>
                <h2 className="text-lg font-bold text-graphite-900">Save Instructions</h2>
                <p className="text-sm text-graphite-500">Select turbines to save the following instructions</p>
              </div>
            </div>
          </div>
          <div className="p-6">
          <div className="max-h-[500px] overflow-y-auto border border-steel-200 rounded-xl">
            <table className="min-w-full">
              <thead className="bg-steel-50 sticky top-0">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">Work Scope</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">Created By</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">Created Time</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">Version</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-steel-100 bg-white">
                {insToSave.map((instr, idx) => (
                  <tr key={idx} className="hover:bg-steel-50 transition-colors">
                    <td className="px-4 py-3 text-sm text-graphite-900 font-medium">{instr.scope_of_work_data.name || "Bez tytułu"}</td>
                    <td className="px-4 py-3 text-sm text-graphite-600">{instr.created_by_data || "Nieznane"}</td>
                    <td className="px-4 py-3 text-sm text-graphite-600">{new Date(instr.created_time).toLocaleString("pl-PL")}</td>
                    <td className="px-4 py-3 text-sm">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-steel-100 text-graphite-700">
                        {instr.version || "N/A"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Pasek postępu podczas zapisywania */}
          {isSaving && (
            <div className="mt-4">
              <p className="text-brand-600 font-semibold mb-2">Saving instructions...</p>
              <div className="w-full bg-steel-200 rounded-full h-2">
                <div className="bg-brand-500 h-2 rounded-full transition-all" style={{ width: `${saveProgress}%` }}></div>
              </div>
            </div>
          )}
          </div>
          {/* Footer with buttons */}
          <div className="px-6 py-4 border-t border-steel-200 bg-steel-50 flex items-center justify-between">
            <div className="text-sm text-graphite-500">
              {selectedTurbines.length > 0 && `${selectedTurbines.length} turbine(s) selected`}
            </div>
            <div className="flex gap-3">
              <button
                onClick={onCancel}
                disabled={isSaving}
                className="px-5 py-2 border border-steel-300 text-graphite-700 rounded-full hover:bg-steel-100 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveAll}
                disabled={isSaving}
                className="px-5 py-2 bg-brand-500 text-white rounded-full hover:bg-brand-600 transition-colors font-medium"
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      );
  };
  
  export default ModalSaveAllInst;
  